<template>
<div class="p-6 bg-indigo-800 min-h-screen flex flex-col justify-center items-center">
    <div class="w-full max-w-md">
    <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
    <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
            <h1 class="text-center font-bold text-3xl">Account Credentials</h1>
            <div class="flex flex-wrap flex-col">
                <div class="mt-4">
                    <label for="first_name" class="form-label" >Your name</label>
                    <div class="form-input">{{ form.first_name}} {{ form.last_name}}</div>
                </div>

                <div class="mt-4" v-if="form.email">
                    <label for="email" class="form-label" >Email</label>
                    <div class="form-input">{{ form.email}}</div>
                </div>

                <div class="mt-4">
                    <label for="mobile" class="form-label" >Mobile</label>
                    <div class="form-input">{{ form.mobile}}</div>
                </div>
            </div>
            <div class="mt-4">
                <p>Please enter a secure password to use at the login screen.</p>
                <text-input required v-model="formData.password" :errors="$page.props.errors.password" class="mt-4 mr-2" label="Password" type="password" />
                <text-input required v-model="formData.password_confirmation" class="mt-4 mr-2" label="Enter Password Again" type="password" />
            </div>

            <div class="mt-4">
                <loading-button :loading="sending" class="btn-primary" type="submit">Register</loading-button>
            </div>

        </div>

    </form>
</div>
</div>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'

export default {
  components: {LoadingButton, Logo, TextInput},

  props: {
    form: {
      type: Object,
      required: true
    },
    secure_url: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      sending: false,
      formData: {
        password: null,
        password_confirmation: null
      }
    }
  },

  methods: {
    submit() {
      this.sending = true;
      this.$inertia.post(this.secure_url, this.formData).then(() => {
        this.sending = false;
      })
    }
  }
}
</script>
